import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Central service holding the currently-selected company logo.
 * Components can subscribe to `logo$` or call `setLogo()` to update it.
 */
@Injectable({ providedIn: 'root' })
export class AppLogoService {
  /** Default fallback logo. */
  private readonly fallbackLogo = 'assets/images/new-images/logo-2.png';

  private logoSubject = new BehaviorSubject<string>(this.fallbackLogo);

  /** Observable stream of the logo url.  */
  readonly logo$ = this.logoSubject.asObservable();

  constructor() {
    // Using static logo only - no API calls
  }

  /**
   * Update the global logo.
   * @param url absolute or relative url. If falsy, default logo is restored.
   */
  setLogo(url?: string, alsoUpdateFavicon: boolean = false): void {
    this.logoSubject.next(url || this.fallbackLogo);
    if (alsoUpdateFavicon) {
      this.updateFavicon(url || this.fallbackLogo);
    }
  }

  /** Replace the <link rel="icon"> href */
  private updateFavicon(iconUrl: string): void {
    const link =
      document.querySelector<HTMLLinkElement>("link[rel~='icon']") ||
      document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/x-icon';
    link.href = iconUrl;
    if (!link.parentElement) {
      document.head.appendChild(link);
    }
  }
}
